import React from "react";
import OnOffGridSitesHeader from "../../../../Components/onOffGridSitesHeader/OnOffGridSitesHeader";
import ApplyFilterHeader from "../../../../Components/ApplyFilterHeader";
import TopTabsHeaders from "../../../../Components/TopTabsHeader/TopTabsHeader";
import InfrastructureWideLineChart from "../../../../Components/Charts/InfrastructureWideLineChart";
import SimpleMapPage from "../../../../Components/Map/MapChart";
import RegionWiseColumnChart from "../../../../Components/Charts/RegionWiseColumnChart";
import ReliabilityGradingRegionWiseHeatMap from "../../../../Components/Charts/ReliabilityGradingRegionWiseHeatMap";
import ProductionSummaryList from "../../../../Components/ProductionSummaryList/ProductionSummaryList";
import EnvironmentalBenefitsList from "../../../../Components/EnvironmentalBenefitsList/EnvironmentalBenefitsList";
import SpHeader from "../../../../Components/mainHeader/SpHeader";
import TeamsViewHeaderDropdown from "../../TeamsViewHeaderDropdown";

function SolarProduction() {
    const pageNo = 5;
    const lineoption = {
        title: {
            text: 'Enegry Generation (KWh)',
            textStyle: {
                fontSize: 18,
                fontWeight: '500',
                fontFamily: 'Roboto, sans-serif',
            },
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            right: '0px',
            top: '4px',
            show: true,
            data: ['Target', 'Actual'],
            fill: 'orange',
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        grid: {
            left: '10px',
            right: '10px',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                boundaryGap: false,
                data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#F0F0F0'
                    }
                },
            }
        ],
        yAxis: [
            {
                type: 'value',
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#F0F0F0'
                    }
                },
            }
        ],

        series: [
            {
                name: 'Target',
                type: 'line',
                color: [
                    '#E3D9F6',
                ],
                stack: 'Actual',
                smooth: true,
                // areaStyle: {normal: {}},
                data: [13, 12, 12, 12.2, 11, 11.5, 13, 13, 13, 13, 13, 13]
            },
            {
                name: 'Actual',
                type: 'line',
                stack: 'YTD',
                smooth: true,
                color: [
                    '#7243D0',
                ],
                // areaStyle: {normal: {}},
                data: [14, 14, 14, 13, 13, 13.5, 0, 0, 0, 0, 0, 0]
            },

        ]
    };

    // 
    const columnchartOptions = {
        title: {
            text: 'Region Wise (KWh',
            textStyle: {
                fontSize: 16,
                fontWeight: '500',
                fontFamily: 'Roboto, sans-serif',
            },
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            right: '0',
            top: '4px',
            show: false,
            data: ['2022', '2023'],
            fill: 'orange',
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        grid: {
            left: '0px',
            right: '10px',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                boundaryGap: true,
                data: ['C4', 'N1', 'C2', 'S1', 'C1', 'C3', 'N3', 'S2', 'N2', 'S3'],
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#F0F0F0'
                    }
                },
            }
        ],
        yAxis: [
            {
                type: 'value',
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#F0F0F0'
                    }
                },
            }
        ],
        series: [
            {
                name: '(Hours/Day)',
                type: 'bar',
                stack: 'YTD',
                smooth: true,
                color: [
                    '#7243D0',
                ],
                // areaStyle: {normal: {}},
                data: [14, 14, 18, 13, 13, 13.5, 4, 14, 14, 13]
            },

        ]
    };

    //
    const productionSummaryData = [
        {
            "id": 1,
            "title": "This Month",
            "value": "7",
            "type": "MWh"
        },
        {
            "id": 2,
            "title": "This Year",
            "value": "1585",
            "type": "MWh"
        },
        {
            "id": 3,
            "title": "Lifetime",
            "value": "5666",
            "type": "MWh"
        }
    ]

    //
    const environmentalBenefitsList = [
        {
            "id": 1,
            "title": "CO2 Emission Saved",
            "value": "42.8",
            "type": "KG",
            "icon": `<svg width="45" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22.5" cy="23" r="22.5" fill="#B35A3E"/>
        <path d="M37.1357 17.116C37.0272 17.0548 36.8941 17.0548 36.7856 17.116L30.5201 20.6625V11.7491C30.5201 11.6267 30.4534 11.5135 30.3449 11.4521C30.2367 11.3909 30.1033 11.3909 29.995 11.4523L23.205 15.2963C23.0965 15.3575 23.0298 15.4707 23.0298 15.5933V23.8108H20.5851L19.9412 15.4281C19.9275 15.2493 19.7755 15.1109 19.5924 15.1109H17.8136C17.6307 15.1109 17.4785 15.2488 17.4644 15.4275L16.8074 23.8107H14.449L13.9174 16.8808C13.9045 16.7012 13.7522 16.5622 13.5687 16.562H11.7887C11.6061 16.562 11.454 16.6999 11.4397 16.8785L10.8943 23.8108H8.38622C8.19337 23.8108 8.03681 23.9634 8.03613 24.1525V26.0845C8.03613 26.1755 8.07312 26.2627 8.13869 26.327C8.20426 26.3915 8.2932 26.4275 8.38622 26.4275H9.3115V34.0232C9.31128 34.1144 9.34826 34.2018 9.41428 34.2663C9.48008 34.3308 9.56948 34.3669 9.6625 34.3667H23.2832C23.2994 34.3664 23.3155 34.3653 23.3316 34.3631C23.3475 34.3653 23.3636 34.3667 23.3797 34.3667H30.1703C30.1848 34.3667 30.1993 34.3655 30.2139 34.3638C30.2284 34.3655 30.2431 34.3667 30.2577 34.3667H36.9606C37.0536 34.3667 37.1428 34.3304 37.2083 34.2661C37.2741 34.2016 37.3109 34.1142 37.3107 34.0232V17.4121C37.3107 17.2895 37.244 17.1763 37.1357 17.1151L37.1357 17.116ZM19.269 15.7978L19.3883 17.3531L18.0156 17.3529L18.1377 15.7976L19.269 15.7978ZM17.9619 18.0392H19.441L19.8837 23.8114H17.5092L17.9619 18.0392ZM13.2455 17.2508L13.3648 18.8062H11.9903L12.1129 17.2508H13.2455ZM11.9363 19.4918H13.4163L13.7474 23.8114H11.5964L11.9363 19.4918ZM8.73601 24.4961H23.0311V25.7421H8.73601V24.4961ZM10.0114 26.4281H23.0315V33.681H10.0114V26.4281ZM29.8204 33.681H23.7297V15.7903L29.8204 12.3438V33.681ZM36.611 33.681H30.5203V21.4549L36.611 18.0075V33.681ZM25.1063 20.4104H28.4441C28.5371 20.4104 28.6261 20.3742 28.6916 20.3099C28.7574 20.2456 28.7942 20.1582 28.7942 20.0672V18.199C28.7942 18.0095 28.6374 17.856 28.4441 17.856H25.1063C25.0133 17.8556 24.9241 17.8916 24.8581 17.9561C24.7923 18.0204 24.7553 18.1078 24.7553 18.199V20.067C24.7551 20.1582 24.792 20.2456 24.8578 20.3101C24.9239 20.3746 25.0133 20.4107 25.1063 20.4104ZM25.4559 18.5425H28.0942V19.7244H25.4559V18.5425ZM25.1063 24.1625H28.4441C28.5369 24.1628 28.6261 24.1267 28.6916 24.0624C28.7572 23.9979 28.7942 23.9107 28.7942 23.8198V21.9529C28.7935 21.7641 28.637 21.6113 28.4441 21.6115H25.1063C25.0135 21.611 24.9245 21.6469 24.8585 21.7109C24.7927 21.775 24.7557 21.862 24.7553 21.9529V23.8211C24.7557 23.9121 24.7927 23.9991 24.8585 24.0631C24.9245 24.1272 25.0135 24.163 25.1063 24.1625ZM25.4559 22.2946H28.0942V23.4765L25.4559 23.4767V22.2946ZM25.1063 27.9177H28.4441C28.6374 27.9177 28.794 27.7642 28.7942 27.5749V25.7064C28.7942 25.6154 28.7572 25.5282 28.6916 25.4639C28.6261 25.3996 28.5369 25.3636 28.4441 25.3636H25.1063C25.0133 25.3634 24.9241 25.3994 24.8581 25.4637C24.7923 25.528 24.7553 25.6154 24.7553 25.7064V27.5749C24.7553 27.6662 24.7925 27.7534 24.8583 27.8176C24.9241 27.8819 25.0133 27.918 25.1063 27.9177ZM25.4559 26.0496H28.0942V27.2315H25.4559V26.0496ZM25.1063 31.6714H28.4441C28.5371 31.6714 28.6261 31.6351 28.6916 31.5709C28.7574 31.5063 28.7942 31.4191 28.7942 31.3282V29.46C28.7942 29.369 28.7572 29.2818 28.6916 29.2175C28.6261 29.1532 28.5369 29.117 28.4441 29.1172H25.1063C25.0133 29.1167 24.9241 29.1528 24.8581 29.2171C24.7923 29.2814 24.7553 29.3688 24.7553 29.46V31.3282C24.7553 31.4194 24.7923 31.5068 24.8581 31.5711C24.9241 31.6356 25.0133 31.6716 25.1063 31.6714ZM25.4559 29.8032H28.0942V30.9851L25.4559 30.9849V29.8032ZM31.8963 27.918L35.2346 27.9177C35.4279 27.9177 35.5844 27.7643 35.5847 27.5749V25.7064C35.5847 25.6154 35.5477 25.5282 35.4821 25.4639C35.4165 25.3996 35.3274 25.3636 35.2346 25.3636H31.8968C31.804 25.3636 31.7148 25.3996 31.6492 25.4639C31.5837 25.5282 31.5467 25.6154 31.5467 25.7064V27.5749C31.5469 27.7643 31.7035 27.9177 31.8968 27.9177L31.8963 27.918ZM32.2464 26.0498H34.8847V27.2317L32.2466 27.2315L32.2464 26.0498ZM31.8968 31.6714H35.2346C35.3274 31.6714 35.4165 31.6351 35.4821 31.5709C35.5477 31.5063 35.5847 31.4191 35.5847 31.3282V29.46C35.5847 29.369 35.5477 29.2818 35.4821 29.2175C35.4165 29.1532 35.3274 29.117 35.2346 29.1172H31.8968C31.804 29.117 31.7148 29.1532 31.6492 29.2175C31.5836 29.2818 31.5467 29.369 31.5467 29.46V31.3282C31.5467 31.5177 31.7034 31.6714 31.8968 31.6714ZM32.2468 29.8032H34.8851V30.9851L32.2466 30.9849L32.2468 29.8032ZM13.725 27.6274H11.7771C11.5838 27.6274 11.4272 27.7811 11.4272 27.9707V29.8793C11.4275 30.0686 11.5842 30.2219 11.7771 30.2219H13.7239C13.8167 30.2219 13.9058 30.1856 13.9714 30.1214C14.037 30.0571 14.0737 29.9696 14.0737 29.8787V27.9707C14.0737 27.7816 13.9178 27.6281 13.725 27.6274ZM13.3749 29.5363H12.1281V28.3139H13.3749V29.5363ZM17.4945 27.6276L15.5478 27.6274C15.3545 27.6274 15.1977 27.7811 15.1977 27.9707V29.8793C15.1982 30.0686 15.3547 30.2219 15.5478 30.2219H17.4945C17.5873 30.2219 17.6763 30.1856 17.7419 30.1214C17.8074 30.0571 17.8442 29.9696 17.8442 29.8787V27.9707C17.8442 27.8797 17.8074 27.7925 17.7419 27.728C17.6763 27.6637 17.5873 27.6274 17.4945 27.6274V27.6276ZM17.1442 29.5363H15.8975V28.3139H17.1442V29.5363ZM21.2634 27.6276L19.3174 27.6274C19.2241 27.6272 19.1347 27.663 19.0687 27.7275C19.0027 27.7918 18.9657 27.8795 18.9657 27.9707V29.8793C18.9659 29.9705 19.0031 30.058 19.0689 30.1222C19.135 30.1863 19.2244 30.2223 19.3174 30.2219H21.2639H21.2637C21.3565 30.2219 21.4456 30.1856 21.5112 30.1214C21.5768 30.0571 21.6138 29.9696 21.6138 29.8787V27.9707C21.6138 27.8797 21.5768 27.7925 21.5112 27.728C21.4456 27.6637 21.3565 27.6274 21.2637 27.6274L21.2634 27.6276ZM20.914 29.5363H19.667V28.3139H20.914V29.5363Z" fill="white"/>
        </svg>`
        },
        {
            "id": 2,
            "title": "Equivalent Trees Planted",
            "value": "3083",
            "type": "Plants",
            "icon": `<svg width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="23" cy="22.5" r="22.5" fill="#0058FF"/>
        <path d="M34.3311 33.7094H11.9802L11.9948 33.2272C12.0629 30.9976 12.7323 29.4651 13.9839 28.6728C15.521 27.7 17.4585 28.1622 18.3037 28.4415C19.7814 25.7031 22.9068 26.0121 24.5847 26.6399C25.4227 26.2166 26.2763 26.1334 27.1262 26.3898C28.921 26.9334 30.1412 28.8594 30.5192 29.5283C32.1563 29.7417 33.3087 30.306 33.9457 31.2065C34.6716 32.2333 34.4276 33.3049 34.4165 33.3497L34.3311 33.7094ZM12.957 32.7733H33.5295C33.519 32.5026 33.4458 32.1145 33.1716 31.7332C32.6691 31.0357 31.6323 30.5848 30.1735 30.4298L29.9193 30.4028L29.8042 30.1738C29.7923 30.1505 28.6028 27.8135 26.8527 27.2854C26.1825 27.082 25.526 27.1739 24.8476 27.562L24.6474 27.6763L24.434 27.5872C24.2694 27.5191 20.3945 25.9428 18.9685 29.2151L18.7821 29.6435L18.3528 29.4574C18.3295 29.4477 16.0423 28.4754 14.4819 29.466C13.5952 30.0289 13.0838 31.1403 12.9571 32.7733L12.957 32.7733Z" fill="white"/>
        <path d="M25.551 19.1411C24.4944 19.1411 23.4228 18.9323 22.4011 18.4915L22.3727 18.4782L21.9352 18.2597L22.1729 17.8323C23.9143 14.2051 28.4639 12.5855 32.3062 14.2421L32.7244 14.4226L32.5599 14.8478C31.2629 17.5497 28.466 19.1411 25.5512 19.1411L25.551 19.1411ZM23.2413 17.8149C26.3569 18.9017 29.8674 17.665 31.4671 14.9174C28.3624 13.8261 24.844 15.0628 23.2413 17.8149Z" fill="white"/>
        <path d="M19.6556 21.1778C16.7813 21.1778 14.2801 19.1366 13.9106 16.3544L13.8087 15.5896L14.591 15.4964C17.7509 15.1219 20.6594 17.2633 21.0593 20.2767V20.2772L21.1603 21.0417L20.3791 21.1349C20.1364 21.1636 19.8945 21.1779 19.6554 21.1779L19.6556 21.1778ZM14.8665 16.4092C15.2798 18.7727 17.5679 20.4473 20.1042 20.2219C19.6912 17.8593 17.4064 16.1889 14.8665 16.4092Z" fill="white"/>
        <path d="M20.9751 19.8881L20.4704 19.3349C19.4582 18.2243 18.9595 16.8053 19.0665 15.3383C19.1743 13.8566 19.8853 12.5075 21.068 11.5393L21.6482 11.063L22.1525 11.6171C23.1647 12.7265 23.6635 14.1456 23.557 15.6127C23.4492 17.0944 22.7382 18.4439 21.5555 19.4122L20.9751 19.8881ZM21.5543 12.3535C20.6363 13.1498 20.0858 14.2288 19.9999 15.4064C19.9153 16.5685 20.2943 17.6964 21.0683 18.5978C21.9867 17.8015 22.5371 16.722 22.6227 15.5444C22.7072 14.3828 22.3287 13.255 21.5543 12.3535Z" fill="white"/>
        <path d="M23.6721 26.7917L22.7879 26.4845C23.5967 24.1529 21.2884 22.5593 21.2652 22.5433L21.223 22.5118C21.1806 22.4756 20.1889 21.6125 20.284 20.3463C20.3575 19.3665 21.0474 18.4632 22.3344 17.6622C27.436 14.4872 29.8416 15.279 29.9399 15.3146L29.6349 16.1996C29.6144 16.1918 27.4789 15.5629 22.8293 18.4567C21.8139 19.0889 21.2717 19.7458 21.2182 20.4093C21.1601 21.1325 21.7179 21.693 21.8179 21.7872C22.8366 22.4902 24.4985 24.4102 23.6724 26.7915L23.6721 26.7917Z" fill="white"/>
        <path d="M20.5556 19.5977C20.2149 16.168 20.8811 15.2743 21.0178 15.1299L21.6972 15.7745L21.3576 15.4522L21.7174 15.7512C21.7123 15.7585 21.1903 16.5114 21.4875 19.5054L20.5556 19.5977Z" fill="white"/>
        <path d="M15.4652 17.5574L16.014 16.7987L20.8696 20.3111L20.3208 21.0698L15.4652 17.5574Z" fill="white"/>
        </svg>`
        },

    ]


    const breadcrumbs = [
        { label: 'Teams View', link: '' },
        { label: 'Solar Production', link: '/SolarProduction' },
    ];
    const summaryObj = {
        minimize: 'Minimise',
        otherName: "Summary",
        minUrl: '/SolarProduction',
        otherUrl: '/TeamsViewSummary',
    }

    return (
        <div className="wrapper">
            <SpHeader breadcrumbs={breadcrumbs} exdb='false' summaryObj={summaryObj} isSummaryButton isSiteDropdown={<TeamsViewHeaderDropdown parentPath='/GridUnavailability' />} />

            <ApplyFilterHeader />
            <div className='pt-1'>
                <TopTabsHeaders pageNo={pageNo} />
            </div>
            <OnOffGridSitesHeader />


            <div className="contentWrap">
                <div className="chart_containter">
                    <div className="row pb-3">
                        <div className="col-8">
                            <div className="box_card">
                                <div className="box_card_inner">
                                    <InfrastructureWideLineChart options={lineoption} />
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="box_card">
                                <div className="box_card_inner">
                                    <SimpleMapPage />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 2nd row */}
                    <div className="row">
                        <div className="col-3">
                            <div className="row">
                                <div className="col-12 pb-3">
                                    <div className="box_card">
                                        <div className="box_card_inner">
                                            <ProductionSummaryList title="Production Summary
" data={productionSummaryData} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 pb-3">
                                    <div className="box_card">
                                        <div className="box_card_inner">

                                            <EnvironmentalBenefitsList title="Environmental Benefits
" data={environmentalBenefitsList} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-3">
                            <div className="box_card">
                                <div className="box_card_inner">
                                    <RegionWiseColumnChart options={columnchartOptions} />
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="box_card">
                                <div className="box_card_inner">
                                    <ReliabilityGradingRegionWiseHeatMap />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default SolarProduction; 